export const Watermark = () => {
  const marks = Array.from({ length: 9 });
  return (
    <div className="pointer-events-none fixed inset-0 z-[5] select-none overflow-hidden" aria-hidden="true">
      <div className="absolute left-[-25%] top-[-25%] grid w-[150%] grid-cols-3 gap-x-48 gap-y-64 rotate-[-28deg] opacity-[0.05]">
        {marks.map((_, i) => (
          <div key={i} className="flex items-center justify-center gap-2 whitespace-nowrap">
            <img src="/antenna_logo.png?v=3" alt="" className="h-6 w-6 object-contain" />
            <span className="font-display text-lg font-black uppercase tracking-tighter text-white">
              NOVA<span className="text-[#8B5CF6]">STREAM</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
